

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { StoreSubscriptionPaymentView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminStoreSubscriptions } from "@/lib/query/core/invalidation";

type CreateStoreSubscriptionPaymentInput = {
  storeId: string;
  paidAt?: string;
  amount?: number;
  markAsPaid?: boolean;
  proofObjectKey?: string;
  proofContentType?: string;
  proofSizeBytes?: number;
};

export function useCreateStoreSubscriptionPaymentMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ storeId, ...body }: CreateStoreSubscriptionPaymentInput) =>
      apiJsonClient<StoreSubscriptionPaymentView>(
        endpoints.admin.storeSubscriptionPayments(storeId),
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        },
      ),
    onSuccess: async (_data, variables) => {
      await invalidateAdminStoreSubscriptions(queryClient, variables.storeId);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
